import { isValidEmail } from '@domain-group/javascript-utils'

const state = {
  active: true,
  address_line_1: '',
  address_line_2: '',
  address_postcode: '',
  address_region: '',
  address_state: '',
  bank_account_bsb: '',
  bank_account_name: '',
  bank_account_number: '',
  billing_type_id: undefined,
  brand_id: undefined,
  brand_theme_id: undefined,
  business_name: '',
  business_number: '',
  campaign_fee_cap: undefined,
  campaign_fee: undefined,
  cover_letter: '',
  data: {},
  email: '',
  fax: '',
  features: {},
  geo_country_id: undefined,
  id: null,
  invoice_pdf_file: null,
  license_number: '',
  locked_by_user_id: undefined,
  options: {
    accounting_platform_api: '',
    crm_sync_api: '',
    default_xero_account: '',
    default_xero_credit_account: '',
    disabled_integration_modules: [],
    electronic_signature_integrable: 'company',
    electronic_signature_provider: '',
    export_settings: {
      height: 1200,
      size: 'original',
      width: 1600,
    },
    include_campaign_fee_on_quotes: true,
    new_quote_default: 'blank',
    payment_terms_unit: 'months',
    payment_terms_value: '',
    quote_payment_template_id: undefined,
    quote_template_id: undefined,
    recalculate_quote_editions: false,
    recalculate_quote_template_prices: true,
    require_artwork_data_sync: true,
    require_quote_authorization: false,
    require_quote_contributions: false,
    require_quote_for_orders: false,
    require_quote_item_required_by_date: false,
    skip_watermark_plans: false,
    sync_xero_payments: '',
    task_prices: {},
    ticketing_system: '',
    watermark_images: [],
    watermark_settings: {
      opacity: 0.7,
      padding: {
        horizontal: 20,
        vertical: 20,
      },
      position: 'south-east',
    },
    workflow_statuses: [],
  },
  phone: '',
  pricing_plan_id: undefined,
  principal_email: '',
  principal_mobile: '',
  principal_name: '',
  quote_pdf_file: null,
  salesforce_id: '',
  short_name: '',
  subscription_fee: null,
  subscription_start_date: '',
  subscription_user_limit: null,
  title: '',
  website: '',
  zuora_account_number: '',

}

export const requiredFields = [
  { key: 'address_line_1' },
  { key: 'address_postcode' },
  { key: 'address_region' },
  { key: 'address_state' },
  { key: 'brand_id' },
  { key: 'email', validation: isValidEmail, invalidMessage: 'Invalid Email format' },
  { key: 'geo_country_id' },
  { key: 'phone' },
  { key: 'title' },
  { key: 'website' },
]

export default state
